import React, {useState} from "react";

import { Classes, Menu, MenuItem, Popover, Tooltip, MenuDivider } from "@blueprintjs/core";
import { CourseWrapper } from "common/entities/courseWrapper/CourseWrapper";
import { getCompletionPercent } from "common/entities/Subscription";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import HeadingView from "common/views/heading/Heading.view";
import PageLinkView from "common/views/pageLink/PageLink.view";
import ProgressBarView from "common/views/progressBar/ProgressBar.view";
import { IDataTableColumn } from "common/views/table/DataTable";
import DateLabel from "core/components/label/DateLabel";
import labelProvider from '../Subscriptions.labels';
import moment from 'moment';
import MutationButton from "common/views/button/MutationButton";
import { CreditEntryUpdate } from "../entities/CreditEntry";
import { Field, MutationType } from "typegraph";
import { DialogView } from "common/views/dialog/Dialog.view";
import { BlockView } from "common/views/block/BlockView.view";
import DropdownSelect from "common/form/widgets/common/DropdownSelect";
import { ISubscriptionsFragmentProps } from "./ISubscriptionsFragmentProps";
import IconView from "common/views/icon/Icon.view";
import DateTimeUtil from "../../../core/util/DateTimeUtil";
import TypographyView from "common/views/typographyView/Typography.view";
import { getProgressTextLabel } from "common/fragments/ProgressText";
import { ID } from "common/entities/IEntity";
import Query from "core/api/QueryComponent";
import Course from "../../../panels/catalog/entities/Course";
import ExtendSubscription from "../../../panels/catalog/fragments/course/extendSubscription";
import * as catalogActions from "../../../panels/catalog/catalogActions";
import claimComplete from "common/fragments/CompleteCreditClaim";
import TimezoneUtil from "core/util/TimezoneUtil";

function mapParams(data) {
	const params = {...data}; //clone

	//remove fields which are not using in query
	delete params['loadPrograms'];

	return {params: params};
}
class CourseQuery {
	@Field({
		entity: Course,
		params: mapParams,
		aliasFor: "course_one"
	})
	public course: Course;
}


const { Labels } = labelProvider;

export const main: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "main",
	sort: "title",
	label: { k: "col.title", v: "Title" },
	primary: true,
	sortable: true,
	enabled: (s) => !!s,
	component: ({subscription, config}) => {
		const wrapper = CourseWrapper.forSubscription(subscription);
		const selfCreditClaim = config.enableSelfClaimCredits || config.enablePartialClaimCredits;
		let claimed = true;
					
		if (selfCreditClaim && subscription.credits && subscription.credits.length) {
			subscription.credits.forEach((credit) => {
				if (credit && credit.granted == false) {
					claimed = false;
				}
			})
		}
		if (!wrapper && subscription && (subscription.entry || subscription.product)) {
			//To show future date subscription
			const title =subscription.entry && subscription.entry.displayName || subscription.product&& (subscription.product.displayName || subscription.product.name);
			return (
				<div>
					<HeadingView viewKey="sub.col.main.title">{title}</HeadingView>
				</div>
			);
		} else if(!wrapper){
			return null;
		}

		const params = {}
		if (subscription && (subscription.entry || subscription.product)) {
			params["id"] = subscription.entry.id;
		}
		let subscriptionEndDatePassed = false;
		if (subscription && subscription.endDate) {
			subscriptionEndDatePassed = new Date() > new Date(subscription.endDate);
		}

		return (
			<div>
				<HeadingView viewKey="sub.col.main.title">{wrapper.getTitle()}</HeadingView>
				<div>
					{/* Call APi to get Course Details Data */}
					{
						subscription && subscription.entry && <Query.Root entity={CourseQuery} args={params}>
						{
							({ data, loading }) => {

								if (loading) {
									return (
										<React.Fragment></React.Fragment>
									);
								}
								const hideViewOnExpired = config.hideView ? !subscriptionEndDatePassed : true;
								const course = data && data.course;
								const cond = course && course.subscriptionEndDate && !course.canExtend && !course.activeSubscriptionExists;
								return <React.Fragment>
									{
										config.subscriptionExpired && cond &&(
											<TypographyView viewKey="subscriptionexpire.title">
												Subscription is Expired
											</TypographyView>
										)
									}

									{(subscription===null || subscription.product===null || (subscription.product.name!=="Self-Reported Activities" && subscription.product.externalId !== "ceactivity" && hideViewOnExpired)) &&  (
										<PageLinkView
										params={{entryId: wrapper.getEntryId()}}
										breadcrumbs={() => {
											const courseKey = 'course:'+ wrapper.getEntryId();
											return [
												{
													key: 'course:' + wrapper.getEntryId(),
													label: {k: wrapper.getEntryId(), v: window.parent.location.pathname.slice(1)},
													target: {
														pathname: window.parent.location.pathname,
														search:  window.parent.location.search,
													},
												},
												{
													key: courseKey,
													label: {k: courseKey, v: wrapper.getTitle()},
													target: {
														pathname: '',
														search: ''
													}
												},
											];
										}}
										viewKey="subs.col.main.viewLink">

											{config.showProgressText && (
												<TypographyView viewKey="subscriptionTable.progressText">
													{getProgressTextLabel(subscription && subscription.completion)}
												</TypographyView>
											)}

											<ButtonView variant={ButtonVariant.CARD_ACTION} viewKey="subs.col.main.details">
												<Labels.CourseView />
											</ButtonView>
										</PageLinkView>
									)}
									&nbsp;&nbsp;
									{
										config.extendSubscription && course && course.canExtend && course.canExtend != undefined &&
										<ExtendSubscription course={course} actions={catalogActions} disableDirectBuy={true} /> 
									}
									&nbsp;&nbsp;
									{
										!subscriptionEndDatePassed && wrapper.isLaunchable() && !cond && (
											<ButtonView viewKey="subs.col.main.launch" variant={ButtonVariant.PRIMARY} onClick={() => wrapper.launchCourse()}>
												<Labels.Launch />
											</ButtonView>
										)
									}
									
								</React.Fragment>

							}
						}
					</Query.Root>
					}

					&nbsp;&nbsp;
					{subscription.certificates && subscription.certificates.length > 0 && (
						<React.Fragment>
							{
								claimed ? (
									<Popover position="bottom" content={
										<Menu>
											{subscription.certificates.map((cert) => (
												cert && cert.id && cert.guid ? (
													<MenuItem
														key={cert.id}
														text={cert.itemName || cert.certificate.name}
														href={`${window.location.origin}/diweb/catalog/cert/id/${cert.guid}/view/1`}
														target="_blank"
													/>
												) : null
											))}
										</Menu>
									}>
										<ButtonView viewKey="subs.col.main.certs" variant={ButtonVariant.PRIMARY}>
											<Labels.certificate />
										</ButtonView>
									</Popover>
								) : <React.Fragment></React.Fragment>
							}
					
					 </React.Fragment>
					)}
				</div>
			</div>
		);
	},
	renderSkeleton: () => (
		<React.Fragment>
			<p className="bp3-skeleton" style={{height: "20px", marginBottom: "10px"}} />
			<p className="bp3-skeleton" style={{height: "25px"}} />
		</React.Fragment>
	)
};

export const score: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "grade",
	sort: "score",
	sortable: true,
	label: {k: "col.score", v: "Score"},
	component: ({subscription}) => {
		if (!subscription.score) {
			return null;
		}

		return (
			<span>
				{subscription.score.toString()}
			</span>
		);
	}
};

export const lastVisited: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "lastVisited",
	sort: "lastVisited",
	sortable: true,
	label: {k: "col.lastVisited", v: "Last Visited"},
	component: ({subscription}) => {
		if (!subscription.lastVisited) {
			return null;
		}

		const adjustedDate = TimezoneUtil.convertDateForSubscription(subscription.lastVisited);
		return (
			<Tooltip content={<DateLabel value={adjustedDate} />}>
				<DateLabel value={adjustedDate} relative={false} style={{ whiteSpace: "nowrap" }} />
			</Tooltip>
		);
	}
};

export const credits: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "credits",
	sort: "credits",
	sortable: false,
	label: {k: "col.credits", v: "Credits"},
	component: ({subscription, config}) => {

		// display product credits if ce credits not exists 
		if (!subscription.credits || subscription.credits.length < 1) {
			if(!subscription.product.credits || subscription.product.credits.length < 1)
				return null;
			return (
				<span>
					{ subscription.product.credits.map((ce) => ce && `0 ${ce.creditType.name}`).join(', ')}
				</span>
			);
		}


		const selfCreditClaim = config.enableSelfClaimCredits || config.enablePartialClaimCredits;
		let content;
		// if self claim enabled and if any credit entry granted is false
		if (selfCreditClaim && subscription.credits.find((c) => c && c.granted === false)) {
			content = subscription.credits.map((ce) => {
				if (ce && ce.granted) { // if already granted
					return <div key={ce.id}>{ce.type.name}: {ce.value}</div>
				}else if(!subscription.validCredit.isValid){
					return <div key={ce.id}>{ce.type.name}: {`0`}</div>
				}else {

					/**Hide claim Button */
					let hide = false;
					let credits: any = config.claimButton		
					if (credits) {
						credits = credits.split(',');
						credits.forEach((c) => { 
							if (c && ce.type.name && c.trim().toLowerCase() == ce.type.name.trim().toLowerCase()) {
								hide = true;
							}
						})
					}
					/**End */

					const partilaClaim = config.enablePartialClaimCredits;
					// partial claim enabled
					if (partilaClaim) {
						const partialIncr = config.partialCreditIncrease;
						const [isOpen, toggleOpen] = useState(false);

						// options for partial claim dropdown
						const options =[];
						for (var idx=ce.value;idx>=partialIncr; idx-=partialIncr) {
							options.push({value:idx, label:idx});
						}
						const [creditVal, setCeditVal] = useState(options[0].value);

						return (
							// show dialogbox on claim button click
							<BlockView viewKey="claim-block" key={ce.id}>
								<DialogView isOpen={isOpen} onClose={() => toggleOpen(!isOpen)} viewKey="dialog" title="Claim Credits"
									onClosed={() => toggleOpen(!isOpen)}>
									<div className={Classes.DIALOG_BODY}>
										<BlockView viewKey="claim.message">
											<Labels.PartialClaimMessage args={{courseName: subscription.entry.displayName || subscription.product.name}}></Labels.PartialClaimMessage>
										</BlockView>
										<BlockView viewKey="claim-dropdown-cont">
											<DropdownSelect
												options={options}
												value={creditVal}
												onChange={setCeditVal}
											/>
										</BlockView>
										<BlockView viewKey="claim-button-cont">
											<MutationButton
												variant={ButtonVariant.PRIMARY}
												viewKey="credit.claim"
												clazz={CreditEntryUpdate}
												params={{id: ce.id, value: creditVal}}
												clearCacheOnSuccess={true}
												method={MutationType.UPDATE}
											>
												<Labels.Claim />
											</MutationButton>
										</BlockView>
									</div>

								</DialogView>

								{ce.type.name}: {ce.value}
								{
									hide ?
										<React.Fragment></React.Fragment> :
										<ButtonView viewKey="claim.button" variant={ButtonVariant.PRIMARY} onClick={() => toggleOpen(!isOpen)}>
											<Labels.Claim />
										</ButtonView>
								}
							</BlockView>
						)
					}
					else return ( // self claim enabled and partial claim not enabled
						<BlockView viewKey="claim-block">
							{ce.type.name}: {ce.value}
							{
								hide ?
									<React.Fragment></React.Fragment> :
									<MutationButton
										key={ce.id}
										variant={ButtonVariant.PRIMARY}
										viewKey="credit.claim"
										clazz={CreditEntryUpdate}
										params={{ id: ce.id, value: ce.value }}
										clearCacheOnSuccess={true}
										method={MutationType.UPDATE}
									>
										<Labels.Claim />
									</MutationButton>
							}
						</BlockView>
					)
				}
				
			});

		} else {
			content = subscription.credits.filter(ce => ce && ce.granted && ce.value > 0).map((ce) => ce && `${ce.value} ${ce.type.name}`).join(', ');
		}

		return (
			<span>
				{content}
				&nbsp;&nbsp;
				{
					config.showCreditClaimButton && subscription.credits.find((c) => c && c.granted === false) &&
					claimComplete(subscription)
				} 
			</span>
		);

	}
};

export const totalCredits: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "totalCredits",
	sort: "totalCredits",
	sortable: false,
	label: {k: "col.totalCredits", v: "totalCredits"},
	component: ({subscription, config}) => {

			return (
				<span>
					{ subscription.product.credits.map((ce) => ce && `${ce.value} ${ce.creditType.name}`).join(', ')}
				</span>
			);
		}
	};

export const ceCredits: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "ceCredits",
	sort: "ceCredits",
	sortable: false,
	label: { k: "col.credits.ce", v: "CE Credits" },
	component: ({subscription, config}) => {
		const credits = subscription.product.credits.filter((ce)=>{
			if (ce.creditType.name.includes('CE') && subscription.validCredit.isValid) {
				return ce;
			}
		});
		const ceCredits = subscription.credits.filter((ce)=>{
			if (ce.type.name.includes('CE') && subscription.validCredit.isValid) {
				return ce;
			}
		});

		// display product credits if ce credits not exists
		if (!ceCredits || ceCredits.length < 1) {
			if(!credits || credits.length < 1)
				return null;
			return (
				<BlockView viewKey="ce-cpe-claim-block">
					{ credits.map((ce) => ce && `${ce.value} ${ce.creditType.name}`).join(', ')}
				</BlockView>
			);
		}

		const selfCreditClaim = config.enableSelfClaimCredits || config.enablePartialClaimCredits;
		let content;
		// if self claim enabled and if any credit entry granted is false
		if (selfCreditClaim && ceCredits.find((c) => c && c.granted === false)) {
			content = ceCredits.map((ce) => {
				if (ce && ce.granted) { // if already granted
					return <div key={ce.id}>{ce.type.name}: {ce.value}</div>
				} else {
					const partilaClaim = config.enablePartialClaimCredits;
					const showCEClaim = Object.keys(config.creditClaimParams).length && config.creditClaimParams['ceCreditClaim'].includes(ce.type.name);
										
					// partial claim enabled
					if (partilaClaim) {
						const partialIncr = config.partialCreditIncrease;
						const [isOpen, toggleOpen] = useState(false);

						// options for partial claim dropdown
						const options =[];
						for (var idx=ce.value;idx>=partialIncr; idx-=partialIncr) {
							options.push({value:idx, label:idx});
						}
						const [creditVal, setCeditVal] = useState(options[0].value);

						return (
							// show dialogbox on claim button click
							<BlockView viewKey="ce-cpe-claim-block">
								<DialogView isOpen={isOpen} onClose={() => toggleOpen(!isOpen)} viewKey="dialog" title="Claim Credits"
									onClosed={() => toggleOpen(!isOpen)}>
									<div className={Classes.DIALOG_BODY}>
										<BlockView viewKey="claim.message">
											<Labels.PartialClaimMessage args={{courseName: subscription.entry.displayName || subscription.product.name}}></Labels.PartialClaimMessage>
										</BlockView>
										<BlockView viewKey="claim-dropdown-cont">
											<DropdownSelect
												options={options}
												value={creditVal}
												onChange={setCeditVal}
											/>
										</BlockView>
										<BlockView viewKey="claim-button-cont">
											<MutationButton
												variant={ButtonVariant.PRIMARY}
												viewKey="credit.claim"
												clazz={CreditEntryUpdate}
												params={{id: ce.id, value: creditVal}}
												clearCacheOnSuccess={true}
												method={MutationType.UPDATE}
											>
												<Labels.Claim />
											</MutationButton>
										</BlockView>
									</div>

								</DialogView>
								{ce.type.name}: {ce.value}
								{
								showCEClaim ? (
								<ButtonView	viewKey="claim.button" variant={ButtonVariant.PRIMARY} onClick={() => toggleOpen(!isOpen)}>
									<Labels.Claim />
								</ButtonView> ) : ''}
							</BlockView>
						)
					}
					else return ( // self claim enabled and partial claim not enabled
						<BlockView viewKey="ce-cpe-claim-block">
							{ce.type.name}: {ce.value}
							{showCEClaim ? (
							<MutationButton
								key={ce.id}
								variant={ButtonVariant.PRIMARY}
								viewKey="credit.claim"
								clazz={CreditEntryUpdate}
								params={{id: ce.id, value: ce.value}}
								clearCacheOnSuccess={true}
								method={MutationType.UPDATE}
							>
								<Labels.Claim />
							</MutationButton> ) : ''}
						</BlockView>
					)
				}


			}
			);
		} else {
			content = ceCredits.filter(ce => ce && ce.granted && ce.value > 0).map((ce) => ce && `${ce.value} ${ce.type.name}`).join(', ');
		}

		return (
			<BlockView viewKey="ce-cpe-claim-block">
				{content}
				{
					config.showCreditClaimButton && ceCredits.find((ce) => ce && ce.granted === false) &&
					claimComplete(subscription)
				} 
			</BlockView>
		);

	}
};


export const cpeCredits: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "cpeCredits",
	sort: "cpeCredits",
	sortable: false,
	label: { k: "col.credits.cpe", v: "CPE Credits" },
	component: ({subscription, config}) => {
		const credits = subscription.product.credits.filter((cpe)=>{
			if (cpe.creditType.name.includes('CPE') && subscription.validCredit.isValid) {
				return cpe;
			}
		});
		const cpeCredits = subscription.credits.filter((cpe)=>{
			if (cpe.type.name.includes('CPE') && subscription.validCredit.isValid) {
				return cpe;
			}
		});
		// display product credits if cpe credits not exists
		if (!cpeCredits|| cpeCredits.length < 1) {
			if(!credits || credits.length < 1)
				return null;
			return (
				<BlockView viewKey="ce-cpe-claim-block">
					{ credits.map((cpe) => cpe && `${cpe.value} ${cpe.creditType.name}`).join(', ')}
				</BlockView>
			);
		}

		const selfCreditClaim = config.enableSelfClaimCredits || config.enablePartialClaimCredits;
		let content;
		// if self claim enabled and if any credit entry granted is false
		if (selfCreditClaim && cpeCredits.find((c) => c && c.granted === false)) {
			content = cpeCredits.map((cpe) => {
				if (cpe && cpe.granted) { // if already granted
					return <div key={cpe.id}>{cpe.type.name}: {cpe.value}</div>
				} else {
					const partilaClaim = config.enablePartialClaimCredits;
					// partial claim enabled
					const showCPEClaim = Object.keys(config.creditClaimParams).length && config.creditClaimParams['cpeCreditClaim'].includes(cpe.type.name);
					if (partilaClaim) {
						const partialIncr = config.partialCreditIncrease;
						const [isOpen, toggleOpen] = useState(false);

						// options for partial claim dropdown
						const options =[];
						for (var idx=cpe.value;idx>=partialIncr; idx-=partialIncr) {
							options.push({value:idx, label:idx});
						}
						const [creditVal, setCeditVal] = useState(options[0].value);
						
						return (
							// show dialogbox on claim button click
							<BlockView viewKey="ce-cpe-claim-block">
								<DialogView isOpen={isOpen} onClose={() => toggleOpen(!isOpen)} viewKey="dialog" title="Claim Credits"
									onClosed={() => toggleOpen(!isOpen)}>
									<div className={Classes.DIALOG_BODY}>
										<BlockView viewKey="claim.message">
											<Labels.PartialClaimMessage args={{courseName: subscription.entry.displayName || subscription.product.name}}></Labels.PartialClaimMessage>
										</BlockView>
										<BlockView viewKey="claim-dropdown-cont">
											<DropdownSelect
												options={options}
												value={creditVal}
												onChange={setCeditVal}
											/>
										</BlockView>
										<BlockView viewKey="claim-button-cont">
											<MutationButton
												variant={ButtonVariant.PRIMARY}
												viewKey="credit.claim"
												clazz={CreditEntryUpdate}
												params={{id: cpe.id, value: creditVal}}
												clearCacheOnSuccess={true}
												method={MutationType.UPDATE}
											>
												<Labels.Claim />
											</MutationButton>
										</BlockView>
									</div>
								</DialogView>
								{cpe.type.name}: {cpe.value}
								{
								showCPEClaim ? (
								<ButtonView	viewKey="claim.button" variant={ButtonVariant.PRIMARY} onClick={() => toggleOpen(!isOpen)}>
									<Labels.Claim />
								</ButtonView> ) : ''}
							</BlockView>
						)
					}
					else return ( // self claim enabled and partial claim not enabled
						<BlockView viewKey="ce-cpe-claim-block">
							{cpe.type.name}: {cpe.value}
							{showCPEClaim ? (
							<MutationButton
								key={cpe.id}
								variant={ButtonVariant.PRIMARY}
								viewKey="credit.claim"
								clazz={CreditEntryUpdate}
								params={{id: cpe.id, value: cpe.value}}
								clearCacheOnSuccess={true}
								method={MutationType.UPDATE}
							>
								<Labels.Claim />
							</MutationButton> ) : ''}
						</BlockView>
					)
				}


			});
		} else {
			content = cpeCredits.filter(cpe => cpe && cpe.granted && cpe.value > 0).map((cpe) => cpe && `${cpe.value} ${cpe.type.name}`).join(', ');
		}

		return (
			<BlockView viewKey="ce-cpe-claim-block">
				{content}
				{
					config.showCreditClaimButton && cpeCredits.find((ce) => ce && ce.granted === false) &&
					claimComplete(subscription)
				} 
			</BlockView>
		);

	}
};

export const actions: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "Actions",
	label: { k: "col.actions", v: "Actions" },
	enabled: ({ subscription }) => {

		if (subscription.credits && subscription.credits.length < 1) {
			return false;
		}
		// Render if subscription is a external activity
		if (subscription.product && subscription.product.externalId === "ceactivity") {
		// Only enable actions if all credits have granted: false
			const allCreditsNotGranted = subscription.credits.every(credit => credit.granted === false);
			return allCreditsNotGranted;
		}
		return false;
	},
	component: ({ config, subscription }) => {
		// Helper function to format date to yyyy-mm-dd after timezone adjustment
		const formatDate = (dateString: string): string => {
			if (!dateString) return '';
			try {
				const adjustedDate = TimezoneUtil.convertDateForSubscription(dateString);
				return moment(adjustedDate).format("YYYY-MM-DD");
			} catch (e) {
				return '';
			}
		};

		// Transform credits to the required format
		const formattedCredits = (subscription.credits || []).map(credit => ({
			id: credit.type && credit.type.id || credit.id || '',
			name: credit.type && credit.type.name || '',
			value: credit.value || 0
		}));

		// Build entry object from subscription data
		const entry = {
			name: subscription.entry && subscription.entry.displayName || '',
			startDate: formatDate(subscription.startDate),
			endDate: formatDate(subscription.endDate),
			completedOn: formatDate(subscription.completedOn),
			credits: formattedCredits,
			subscriptionId: subscription.id,
		};

		return (
			<PageLinkView
				attrs={
					subscription && {
						"data-wap_ref": `${subscription.id}:${subscription.product && subscription.product.id
							}`
					}
				}
				params={{
					subscriptionId: subscription.id as ID,
					entry: JSON.stringify(entry)
				}}
				viewKey="edit.credit.link"
			>
				<ButtonView
					variant={ButtonVariant.PRIMARY}
					viewKey="edit.credit.button"
				>
					Edit Credits
				</ButtonView>
			</PageLinkView>
		);
	}
};

export const completion: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "completion",
	sort: "completion",
	sortable: false,
	label: {k: "col.completion", v: "Completion"},
	component: ({subscription}) => (
		// <ProgressBarView viewKey="progress" value={getCompletionPercent(subscription)} />
		subscription && subscription.product && subscription.product.type.baseType === "base:package" ? <React.Fragment><TypographyView style={{textAlign:"center"}} viewKey="subscriptionTable.progressPercent">{parseInt(subscription.completionPercentage)+"%"}</TypographyView><ProgressBarView viewKey="progress" value={Number(subscription.completionPercentage)/100} /></React.Fragment>: <ProgressBarView viewKey="progress" value={getCompletionPercent(subscription)} />
	)
};

export const daysToAccess: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "daysToAccess",
	sort: "daysToAccess",
	label: {k: "col.daysToAccess", v: "Days To Access"},
	component: ({subscription}) => {
		if (!subscription.endDate) {
			return null;
		}
		const enddate  = moment(subscription.endDate);
		const days = enddate.diff(moment(),'days');
		if(days<0){
			return null;
		}
		return (
			<span>
				{days.toString().concat(' Days')}
			</span>
		);
	}
};

export const startDate: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "startDate",
	sort: "startDate",
	sortable: true,
	label: {k: "col.startDate", v: "Start Date"},
	component: ({subscription}) => {
		if (!subscription.startDate) {
			return null;
		}
		const adjustedDate = TimezoneUtil.convertDateForSubscription(subscription.startDate);
		return (
			<span>
				<DateLabel value={adjustedDate}></DateLabel>
			</span>
		);

	}
};

export const endDate: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "endDate",
	sort: "endDate",
	sortable: true,
	label: {k: "col.endDate", v: "End Date"},
	component: ({subscription}) => {
		if (!subscription.endDate) {
			return null;
		}
		const adjustedDate = TimezoneUtil.convertDateForSubscription(subscription.endDate);
		return (
			<span>
				<DateLabel value={adjustedDate}></DateLabel>
			</span>
		);
	}
};

export const completionDate: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "completionDate",
	sort: "completedOn",
	sortable: true,
	label: {k: "col.completionDate", v: "Completion Date"},
	component: ({subscription}) => {
		if (!subscription.completedOn) {
			return null;
		}
		const adjustedDate = TimezoneUtil.convertDateForSubscription(subscription.completedOn);
		return (
			<React.Fragment>
				<DateLabel value={adjustedDate}></DateLabel>
			</React.Fragment>
		);
	}
};

export const timeSpent: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "timeSpent",
	label: {k: "col.timeSpent", v: "Time Spent"},
	component: ({subscription}) => {
		if (!subscription.timeSpent) {
			return null;
		}

		return (
			<span>
				{DateTimeUtil.formatDurationHHMMSS(subscription.timeSpent)}
			</span>
		);
	}
};

export const certificates: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "certificates",
	label: {k: "col.certificates", v: "Certificates"},
	enabled: ({subscription}) => (!!subscription.certificates && subscription.certificates.length > 0),
	component: ({subscription}) => (
			<Popover
				key="certificates"
				content={
					<Menu>
						<MenuDivider title={<Labels.certificates args={{count: subscription.certificates.length}}/>} />
						{
							subscription.certificates.map((cert) => (
								<MenuItem
									key={cert.id}
									href={`${window.location.origin}/diweb/catalog/cert/id/${cert.guid}/view/1`}
									target="_blank"
									text={cert.certificate && cert.certificate.name || "Untitled Certificate"}
								/>
							))
						}
					</Menu>
				}
			>
				<IconView icon="bookmark" viewKey="subscription-certificates">
					<Labels.certificates args={{count: subscription.certificates.length}}/>
				</IconView>
			</Popover>
	)
};


export const customField1: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "customField1",
	sort: "customField1",
	sortable: true,
	label: {k: "col.customField1", v: "Custom Field 1"},
	component: ({subscription}) => {
		if (!subscription) {
			return null;
		}
		return (
			<span>
				{ subscription.product && subscription.product.customField1? subscription.product.customField1: ""}
			</span>
		);
	}
};


export const customField2: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "customField2",
	sort: "customField2",
	sortable: true,
	label: {k: "col.customField2", v: "Custom Field 2"},
	component: ({subscription}) => {
		if (!subscription) {
			return null;
		}
		return (
			<span>
				{ subscription.product && subscription.product.customField2? subscription.product.customField2: ""}
			</span>
		);
	}
};


export const customField3: IDataTableColumn<ISubscriptionsFragmentProps, any> = {
	name: "customField3",
	sort: "customField3",
	sortable: true,
	label: {k: "col.customField3", v: "Custom Field 3"},
	component: ({subscription}) => {
		if (!subscription) {
			return null;
		}
		return (
			<span>
				{ subscription.product && subscription.product.customField3? subscription.product.customField3: ""}
			</span>
		);
	}
};



// WEBPACK FOOTER //
// ./src/panels/subscriptions/fragments/subscriptionFragments.tsx